<template lang="pug">
    div#login(v-if="!$store.state.isUserLoggedIn")
        Login

    div#app.admin(v-else="$store.state.isUserLoggedIn")
        PageHeader
        div.main
            div.row.cf__menu(v-if="route.category !== undefined")
                div.container.mt30
                    div.menu.wh_bl.mb0
                        a.link(href="/admin")
                            include ../snippets/home.pug
                        a.link(:href="link.link" v-cloak :class="{'is-active': route.path === link.path}" :attr="link.path" v-for="(link, index) in arrLink[route.category]" :key="index") {{link.name}}

            div.row.cf__menu(v-else-if="route.back")
                div.container.mt30
                    div.menu.wh_bl.mb0
                        a.link(@click="$router.go(-1)")
                            span.mr10
                                include ../snippets/arrow-prev.pug
                            | Вернуться

            router-view
</template>

<script>
    import PageHeader from '@/admin/components/Header.vue'
    import Login from '@/admin/components/Login.vue'

    const links = {
        words: [
            {name: 'Список слов',    path: 'words', link: '/admin/words?page=1'},
            {name: 'Добавить слово', path: 'add-words', link: '/admin/add-words'},
            {name: 'Модерация слов', path: 'new-words', link: '/admin/new-words?page=1'}
        ],
        users: [
            {name: 'Пользователи',  path: 'users', link: '/admin/users?page=1'},
            {name: 'Добавить пользователя', path: 'add-users', link: '/admin/add-users'}
        ]
    };

    export default {
        name: "Admin",
        data() {
            return {
                route: '',
                arrLink: links
            }
        },
        components: {
            PageHeader,
            Login
        },
        watch: {
            '$route': {
                immediate: true,
                async handler(value) {
                    this.route = {
                        back: value.meta.back,
                        path: value.name,
                        category: value.meta.category
                    }
                }
            }
        },
        computed: {
            router() {
                return this.$router
            },
        },
    }
</script>

<style lang="scss">
    @import "scss/app";
</style>
